import { render, staticRenderFns } from "./AulaPratica.vue?vue&type=template&id=4e8f343e&scoped=true"
import script from "./AulaPratica.vue?vue&type=script&lang=js"
export * from "./AulaPratica.vue?vue&type=script&lang=js"
import style0 from "./AulaPratica.vue?vue&type=style&index=0&id=4e8f343e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f343e",
  null
  
)

export default component.exports